import { defineStore, type Store } from "pinia";

import findIndex from "lodash-es/findIndex";
import { MiaPlaza } from "../../../Reinforced.Typings";

type Culture = string;

/** Default localStorage cache TTL */
const DEFAULT_CACHE_EXPIRATION_TIME_MS = 7 * 24 * 60 * 60 * 1000;

/** Default MultiloadAdapter debounce */
const DEFAULT_MULTILOAD_DEBOUNCE_MS = 250;

export const HUMAN_CULTURES = [MiaPlaza.Control.Vue.I18Next.US];
export const CULTURES = [MiaPlaza.Control.Vue.I18Next.C, ...HUMAN_CULTURES];

export interface State {
	culture: Culture
	xhr: string
	version: string
	cacheExpirationTimeMs: number
	multiloadDebounceMs: number
}

export interface Actions {
	setCulture(culture?: Culture): void
}

export type I18NextStore = Store<string, State, {}, Actions>;

export function defineI18NextStore(
	culture: Culture,
	xhr: string,
	version: string,
	cacheExpirationTimeMs: number = DEFAULT_CACHE_EXPIRATION_TIME_MS,
	multiloadDebounceMs: number = DEFAULT_MULTILOAD_DEBOUNCE_MS,
): I18NextStore {
	return defineStore(MiaPlaza.Control.Vue.I18Next.STORE, {
		state: (): State => ({
			culture,
			xhr,
			version,
			cacheExpirationTimeMs,
			multiloadDebounceMs,
		}),
		actions: {
			setCulture(culture?: Culture) {
				if (culture != null) {
					this.culture = culture;
				}
				else {
					this.culture = CULTURES[(findIndex(CULTURES, (c) => c === this.culture) + 1) % CULTURES.length];
				}
			},
		},
	});
}

export function useI18NextStore(): I18NextStore {
	return defineStore(MiaPlaza.Control.Vue.I18Next.STORE, {
		state: () => { throw Error("I18NextStore must be created with defineI18NextStore() before it can be used"); },
	})();
}
